export const iconFontAwesomeAnimalsFeatherPointed = (
	<i className="fa-solid fa-feather-pointed"></i>
);
